import { render } from "./InputFile.vue?vue&type=template&id=2e8df686"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=2e8df686&lang=scss"
script.render = render

export default script